import React from "react";
import { Form, Col } from "react-bootstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";
import FilterationBarContainer from "../../../components/FilterationBarContainer";

function FilterationBar(props) {
	const {
		months,
		selectedMonth,
		years,
		selectedYear,
		status,
		selectedStatus,
	} = props;
	return (
		<FilterationBarContainer>
			{/*Sort by*/}
			<Col lg={4} className="mb-1">
				<Form.Group className="input-field">
					<Form.Label className="label">Sort by</Form.Label>
					<Col>
						<CustomReactSelect
							options={years}
							value={selectedYear}
							onChange={(value) => props.onYearChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>

			{/*Month*/}
			<Col lg={4} className="mb-1">
				<Form.Group className="input-field">
					<Form.Label className="label">Month</Form.Label>
					<Col>
						<CustomReactSelect
							options={months}
							value={selectedMonth}
							onChange={(value) => props.onMonthChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>

			{/*Status*/}
			<Col lg={4}>
				<Form.Group className="input-field">
					<Form.Label className="label">Status</Form.Label>
					<Col>
						<CustomReactSelect
							options={status}
							value={selectedStatus}
							onChange={(value) => props.onStatusChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>
		</FilterationBarContainer>
	);
}

export default FilterationBar;
